import { render, staticRenderFns } from "./Mmun.vue?vue&type=template&id=34bbdff8&scoped=true&"
import script from "./Mmun.vue?vue&type=script&lang=js&"
export * from "./Mmun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bbdff8",
  null
  
)

export default component.exports